import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../styles/ProductImagesSlider.css";

import { Navigation } from "swiper/modules";
import { useState } from "react";

export default function ProductImagesSlider({
  images,
  productName,
  showPagination,
}) {
  const [currentIndex, setCurrentIndex] = useState(1);

  const handleSlideChange = (swiper) => {
    setCurrentIndex(swiper.realIndex + 1);
  };

  return (
    <div className="swiper-wrapper-container">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        navigation={true}
        modules={[Navigation]}
        className="mySwiper custom-swiper"
        onSlideChange={handleSlideChange}
        onInit={(swiper) => setCurrentIndex(swiper.realIndex + 1)}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              className={showPagination ? "default-size" : "aspect-ratio"}
              src={`/${image}`}
              alt={`${productName} ${index}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      {showPagination && (
        <div className="image-indicator">
          {currentIndex} | {images.length}
        </div>
      )}
    </div>
  );
}
